import { c as _c } from "react/compiler-runtime";
import type { Rule, RuleAction } from '@onefootprint/request-types/dashboard';
import { Card } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import RuleRow from '@/entities/components/details/components/content/components/rule-row';
import CardGrid from '../../../card-grid';
import CardTitle from '../../../card-title';
type ContentProps = {
  ruleResults: Partial<Record<RuleAction, Rule[]>>;
  showTriggered: boolean;
};
const Content = t0 => {
  const $ = _c(11);
  const {
    ruleResults,
    showTriggered
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.rules"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== t) {
    t2 = action => {
      switch (action) {
        case "pass_with_manual_review":
          {
            return t(_temp);
          }
        case "manual_review":
          {
            return t(_temp2);
          }
        case "fail":
          {
            return t(_temp3);
          }
        case "step_up.identity":
          {
            return t(_temp4, {
              requirement: t(_temp5)
            });
          }
        case "step_up.proof_of_address":
          {
            return t(_temp6, {
              requirement: t(_temp7)
            });
          }
        case "step_up.identity_proof_of_ssn":
          {
            return t(_temp8, {
              requirement: t(_temp9)
            });
          }
        case "step_up.identity_proof_of_ssn_proof_of_address":
          {
            return t(_temp10, {
              requirement: t(_temp11)
            });
          }
        case "step_up.custom":
          {
            return t(_temp12, {
              requirement: t(_temp13)
            });
          }
      }
    };
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getActionTitle = t2;
  if (Object.keys(ruleResults).length === 0) {
    let t3;
    if ($[3] !== showTriggered || $[4] !== t) {
      t3 = showTriggered ? t(_temp14) : t(_temp15);
      $[3] = showTriggered;
      $[4] = t;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== t3) {
      t4 = <Card.Root><Card.Empty>{t3}</Card.Empty></Card.Root>;
      $[6] = t3;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  let t3;
  if ($[8] !== getActionTitle || $[9] !== ruleResults) {
    t3 = <CardGrid className="w-full">{Object.entries(ruleResults).map(t4 => {
        const [action_0, rules] = t4;
        const title = getActionTitle(action_0 as RuleAction) ?? action_0;
        return <Card.Root key={action_0} role="group" aria-label={title} className="flex flex-col"><CardTitle title={title} count={rules.length} /><Card.Body className="flex-1 px-4 pt-4 pb-2"><ul>{rules.map(_temp16)}</ul></Card.Body></Card.Root>;
      })}</CardGrid>;
    $[8] = getActionTitle;
    $[9] = ruleResults;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
export default Content;
function _temp($_11) {
  return $_11.action.passWithManualReview;
}
function _temp2($_10) {
  return $_10.action.manualReview;
}
function _temp3($_9) {
  return $_9.action.fail;
}
function _temp4($_7) {
  return $_7.action.stepUpTo;
}
function _temp5($_8) {
  return $_8.action.identity;
}
function _temp6($_5) {
  return $_5.action.stepUpTo;
}
function _temp7($_6) {
  return $_6.action.proofOfAddress;
}
function _temp8($_3) {
  return $_3.action.stepUpTo;
}
function _temp9($_4) {
  return $_4.action.identityProofOfSsn;
}
function _temp10($_1) {
  return $_1.action.stepUpTo;
}
function _temp11($_2) {
  return $_2.action.identityProofOfSsnProofOfAddress;
}
function _temp12($) {
  return $.action.stepUpTo;
}
function _temp13($_0) {
  return $_0.action.custom;
}
function _temp14($_12) {
  return $_12.noTriggeredRules;
}
function _temp15($_13) {
  return $_13.noNotTriggeredRules;
}
function _temp16(t0) {
  const {
    ruleId,
    ruleExpression
  } = t0;
  return <RuleRow key={ruleId} ruleExpression={ruleExpression} />;
}